<template>
  <div class="d-flex flex-column" style="height: 100%">
    <!-- <div class="row justify-content-start py-2 flex-wrap m-0">
      <div
        class="d-flex align-items-center mx-4"
        style="cursor: pointer"
        @click="GoAction('')"
      >
        <b-icon icon="arrow-return-left" flip-v></b-icon>
        <label class="m-0 event_label" style="cursor: pointer">回上頁</label>
      </div>
      <button class="main-btn center" @click="toMain">
        <img src="@/assets/icon-SPA.png" alt="" />克麗緹娜SPA
      </button>
    </div>
    <div class="row justify-content-between py-2 flex-wrap m-0 cust_sec_head">
      <div class="d-flex align-items-center">
        <label class="m-0 ml-4" style="font-size: 2rem; color: #ff5c00; font-weight: bolder">克麗緹娜SPA</label>
      </div>
    </div> -->
    <div class="flex-grow-1 Main_css">
      <div class="col-12">
        <router-view></router-view>
      </div>
    </div>

    <!-- <div class="col-12 row m-0 p-0 spa-footer px-5">
      <div class="col-3 row m-0 justify-content-center">
        <div class="spa-footer-card p-3" @click="GoAction('SpaReservedMain')"
          :class="{ 'selected': selected === 'SpaReservedMain' }">
          <img :src="$Img.url + 'SPA/Icon-預約.png'"></img>
          <div class="mt-2">預約</div>
        </div>
      </div>
      <div class="col-3 row m-0 justify-content-center">
        <div class="spa-footer-card p-3" @click="GoAction('SpaRecord')"
          :class="{ 'selected': selected === 'SpaRecord' }">
          <img :src="$Img.url + 'SPA/Button-預約紀錄.png'"></img>
          <div class="mt-2">預約紀錄</div>
        </div>
      </div>
      <div class="col-3 row m-0 justify-content-center">
        <div class="spa-footer-card p-3" @click="GoAction('News')" :class="{ 'selected': selected === 'News' }">
          <img :src="$Img.url + 'SPA/Icon-最新消息.png'"></img>
          <div class="mt-2">最新消息</div>
        </div>
      </div>

    </div> -->
  </div>
</template>
<script>
export default {
  name: 'Home',
  components: {},
  data() {
    return {
      SuplNO: '',
      selected: null
    };
  },
  watch: {},
  mounted() {
    this.GoAction('SpaReservedMain');
  },
  methods: {
    GoAction(name) {
      this.selected = name;
      if (name == '') {
        if (this.$route.name == 'SpaReservedMain') {
          name = 'MainPage';
        }
        if (this.$route.name == 'SpaItems') {
          name = 'SpaReservedMain';
        }
        if (this.$route.name == 'SpaCalendar') {
          name = 'SpaReservedMain';
        }
        if (this.$route.name == 'SpaReserved') {
          name = 'SpaCalendar';
        }
        if (this.$route.name == 'SpaRecord') {
          name = 'SpaReservedMain';
        }
        if (this.$route.name == 'News') {
          name = 'SpaReservedMain';
        }
      }
      //return
      this.$router.push({
        name: name
      });
    },
    Msg(msg, sec, type) {
      this.$parent.Msg(msg, sec, type);
    },
    toMain() {
      this.$router.push({
        name: 'SpaReservedMain'
      });
    }
  }
};
</script>
<style scoped>
.event_label {
  margin-left: 10px !important;
  font-size: 1.5rem;
  color: #a37e5c;
  font-weight: 600;
}

.Main_css {
  background-color: #faf7f2;
}

.cust_sec_head {
  background: linear-gradient(to right, #fcedd0, white);
}

.spa-footer {
  width: 100%;
  height: 150px;
  position: fixed;
  bottom: 0;
  background-color: #faf7f2;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.spa-footer-card {
  width: 160px;
  height: 120px;
  background-color: white;
  border-radius: 0.5rem;
  border: 1px solid #e27814;
  font-weight: bold;
  cursor: pointer;
}

.spa-footer-card:hover {
  border: 3px solid #e27814;
}

.spa-footer-card.selected {
  border: 3px solid #e27814;
}

img {
  width: 61px;
  height: 61px;
}

.main-btn {
  background-color: white;
  color: #a37e5c;
  border: 1px solid #e27814;
  border-radius: 4px;
}

.main-btn img {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/View/Spa/SpaMain.vue